import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import CommonPrivateRoute from '@/common/router/PrivateRoute';

import DefaultLayout from '../components/layouts/DefaultLayout/DefaultLayout';

const PrivateRoute = (props) => {
  const { noDefaultLayout } = props;
  const defaultLayoutProps = {};
  if (!noDefaultLayout) {
    defaultLayoutProps.defaultLayout = {
      Component: DefaultLayout,
    };
  }

  return (
    <CommonPrivateRoute
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...defaultLayoutProps}
    />
  );
};

PrivateRoute.defaultProps = {
  layout: {
    Component: Fragment,
    props: {},
  },
  noDefaultLayout: false,
};

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  layout: PropTypes.shape({
    Component: PropTypes.elementType,
    // eslint-disable-next-line react/forbid-prop-types
    props: PropTypes.object,
  }),
  noDefaultLayout: PropTypes.bool,
};

export default PrivateRoute;
